<template>
    <div :key="activeTab" class="widget-top-list" style="background-color: #F8F8F8">
        <span class="widget-top-list__title">Топ ипотечных банков</span>
        <span class="widget-top-list__subtitle">Ежемесячный рейтинг крупнейших ипотечных банков страны: объем выдачи
            кредитов,
            динамика ипотечного портфеля</span>
        <div class="b_tab-wrp">
            <button class="b_tab-button" :class="{ 'active': activeTab === 0 }" data-tab="0" @click="activeButton($event)">
                Ипотека всего
            </button>
            <button class="b_tab-button" :class="{ 'active': activeTab === 1 }" data-tab="1" @click="activeButton($event)">
                Ипотека ИЖС
            </button>
        </div>
        <custom-select :options="getOptions" :reset-btn="false" class="select" :tabindex="0" @input="setSelected" />
        <div v-if="options.length > 0">
            <div class="table-row">
                <ul class="">
                    <li v-for="(option, i) in options" :key="i" class="table-row-item">
                        <div class="table-row__title">
                            <span>{{ option[0] }}</span>
                        </div>
                        <div class="table-row__data">
                            {{ option[1] }}
                        </div>
                        <div class="table-row__percent">
                            {{ option[2] }}
                        </div>
                    </li>
                </ul>
            </div>
            <div class="widget-top-list__source">
                <span class="widget-top-list__source-txt">Источник: </span>
                <span class="widget-top-list__source-val">{{ source }}</span>
            </div>
            <div class="widget-top-list-footer">
                <div class="widget-top-list__link">
                    <a
                        :href="mortgageTopBanks.props.file.src"
                        class="widget-top-list__link-r"
                        :title="mortgageTopBanks.props.file.name"
                        target="_blank"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                fill-rule="evenodd" clip-rule="evenodd"
                                d="M18.7786 6.67169C18.7922 6.13306 18.3667 5.70747 17.828 5.72112L9.05043 5.94353C8.5118 5.95718 8.06408 6.40489 8.05043 6.94353C8.03678 7.48216 8.46237 7.90775 9.00101 7.8941L15.424 7.73135L6.52455 16.6308C6.13403 17.0214 6.11838 17.6389 6.4896 18.0101C6.86082 18.3813 7.47834 18.3657 7.86887 17.9752L16.7684 9.07567L16.6056 15.4987C16.592 16.0373 17.0176 16.4629 17.5562 16.4493C18.0948 16.4356 18.5425 15.9879 18.5562 15.4493L18.7786 6.67169Z"
                                fill="#82BF00"
                            />
                        </svg>
                        Читать
                    </a>
                    <a href="/analytics/archive/?section=838" target="_blank" title="Архив отчетов" class="widget-top-list__link-a">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                fill-rule="evenodd" clip-rule="evenodd"
                                d="M18.7786 6.67169C18.7922 6.13306 18.3667 5.70747 17.828 5.72112L9.05043 5.94353C8.5118 5.95718 8.06408 6.40489 8.05043 6.94353C8.03678 7.48216 8.46237 7.90775 9.00101 7.8941L15.424 7.73135L6.52455 16.6308C6.13403 17.0214 6.11838 17.6389 6.4896 18.0101C6.86082 18.3813 7.47834 18.3657 7.86887 17.9752L16.7684 9.07567L16.6056 15.4987C16.592 16.0373 17.0176 16.4629 17.5562 16.4493C18.0948 16.4356 18.5425 15.9879 18.5562 15.4493L18.7786 6.67169Z"
                                fill="#82BF00"
                            />
                        </svg>Архив отчетов
                    </a>
                </div>
                <div class="widget-list__btn">
                    <ui-button href="/analytics/mortgage/">
                        Ипотечная аналитика
                    </ui-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CustomSelect from './ui/CustomSelect';
import UiButton from './ui/UiButton';

export default {
    name: 'WidgetTopList',
    components: { CustomSelect, UiButton },
    // eslint-disable-next-line vue/require-prop-types
    props: ['mortgageTopBanksIzhs', 'mortgageTopBanks'],
    data() {
        return {
            options: [],
            selectOption: [],
            activeIndex: null,
            activeTab: 0,
            source: null,
        };
    },
    computed: {
        getOptions() {
            if (this.activeTab === 0) {
                this.setSource(this.$props.mortgageTopBanks.source);
                return this.$props.mortgageTopBanks.props.table;
            }
            this.setSource(this.$props.mortgageTopBanksIzhs.source);
            return this.$props.mortgageTopBanksIzhs.props.table;
        }
    },
    mounted() {

    },
    methods: {
        setSelected(option) {
            this.options = option.values;
        },
        setSource(source) {
            this.source = source;
        },
        activeButton(el) {
            this.activeTab = Number(el.target.dataset.tab);
        },
        getJson(json) {
            return JSON.stringify(JSON.parse(json), null, 4);
        },

    }
};
</script>
